export enum FlowStepType {
  RoleSelector = 'RoleSelector',
  Source = 'Source',
  ProfilePhone = 'ProfilePhone',
  ListingBooking = 'ListingBooking',
  ListingPhotos = 'ListingPhotos',
  ListingLocation = 'ListingLocation',
  ListingDescription = 'ListingDescription',
  ListingMultiSite = 'ListingMultiSite',
  ListingTerrain = 'ListingTerrain',
  ListingSiteManagement = 'ListingSiteManagement',
  SiteAmenities = 'SiteAmenities',
  SiteActivities = 'SiteActivities',
  SiteIsolation = 'SiteIsolation',
  SiteBoondockLand = 'SiteBoondockLand',
  SiteRVs = 'SiteRVs',
  SiteDetails = 'SiteDetails',
  SitePrice = 'SitePrice',
  ListingRules = 'ListingRules',
  SiteLocation = 'SiteLocation',
  SiteDescription = 'SiteDescription',
  UserProfilePhoto = 'UserProfilePhoto',
  UserGarage = 'UserGarage',
  UserRv = 'UserRv',
  UserRvImage = 'UserRvImage',
  UserRvSize = 'UserRvSize',
  UserRoadConditions = 'UserRoadConditions',
  UserTent = 'UserTent',
  UserComplete = 'UserComplete',
  SitePhotos = 'SitePhotos',
  ListingPublish = 'ListingPublish',
  SalesContact = 'SalesContact',
  ListingSalesPublish = 'SiteSalesPublish',
}
